import request from './api'
import {periodDayKey} from '../utils/date.utils'

export async function getReads(pointsMas, periodStart, periodEnd, typeReads) {
    try {
        const data = await request('/api/point/reads','POST',{
            points: pointsMas,
            start: periodStart,
            end: periodEnd,
            type: typeReads
        })
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getToken(kod_point) {
    try {
        const data = await request('/api/isue/get-token','POST',{kod_point})
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message,
            code: e.code
        }
    }
}

export async function getDogToken(kod_dog) {
    try {
        const data = await request('/api/isue/get-dog-token','POST',{kod_dog})
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message,
            code: e.code
        }
    }
}

export async function getTokenUk(kod_object) {
    try {
        const data = await request('/api/isue/get-token-uk','POST',{kod_object})
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message,
            code: e.code
        }
    }
}

export async function getPoint(kodPoint) {
    try {
        const data = await request('/api/point/point','POST',{
            point: kodPoint
        })
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getPointPus(kodPoint) {
    try {
        const data = await request('/api/point/pus','POST',{
            point: kodPoint
        })
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getRashod(pointsMas, periodStart, periodEnd) {
    try {
        const data = await request('/api/point/rashod','POST',{
            points: pointsMas,
            start: periodStart,
            end: periodEnd
        })
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getOutVals(pointMas, period1, period2, type, dogovor) {
    try {
        const data = await request('/api/point/outvals','POST',{
            points: pointMas,
            date_start: periodDayKey(new Date(period1)),
            date_end: periodDayKey(new Date(period2)),
            type: type,
            dogovor: dogovor
        })
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

/** G398: почасовка с знаками ± и пиковыми часами. points: [{kod_point, sign}] */
export async function getOutValsSigned(points, period1, period2, allowEmpty = false, extra = {}) {
    try {
        const data = await request('/api/point/outvals-signed', 'POST', {
            points,
            date_start: periodDayKey(new Date(period1)),
            date_end: periodDayKey(new Date(period2)),
            allow_empty: allowEmpty,
            flags_only: extra.flagsOnly || undefined,
            kod_dog: extra.kodDog || undefined,
        })
        return {
            isOk: true,
            data,
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message,
        }
    }
}

export async function sendIntegralAkt(formData){
    try {
        const data = await request('/api/point/integral-akt', 'PUT', formData, 'multipart')
        return {
            isOk: true,
            message: data.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function sendIntegralReads(period, reads){
    try {
        const data = await request('/api/point/reads', 'PUT', {period: period, reads: reads}
        )
        return {
            isOk: true,
            message: data.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function sendIntervalAkt(formData){
    try {
        const data = await request('/api/point/interval-akt', 'PUT', formData, 'multipart')
        return {
            isOk: true,
            message: data.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function createTaskUK(formData){
    try {
        const data = await request('/api/prebill/task-uk', 'POST', formData, 'multipart')
        return {
            isOk: true,
            message: data.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getHistory(kod_dog){
    try {
        const data = await request('/api/prebill/history', 'POST', {kod_dog})
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function downloadFile(file_id){
    try {
        const data = await request('/api/prebill/download?file_id='+file_id, 'GET')
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getCountNotReads(dogovor){
    try {
        const data = await request('/api/point/not-reads', 'POST', {
            dogovor: dogovor
        })
        return {
            isOk: true,
            data: data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getEnergosferaCounter(kodPoint, period1, period2, interval = 'half-hour', codeFact = null) {
    try {
      const res = await request('/api/point/energo-counter','POST', {
          point: kodPoint,
          period1: periodDayKey(new Date(period1)),
          period2: periodDayKey(new Date(period2)),
          interval,
          code_fact: codeFact || undefined,
      })
      return {
          isOk: true,
          data: res
      }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function getFileEnergosferaCounter( points, period1, period2, typeReads, kodDog, interval = 'half-hour' ) {
    try {
        const res = await request('/api/point/energo-counter-file','POST', {
            points,
            period1: periodDayKey(new Date(period1)),
            period2: periodDayKey(new Date(period2)),
            typeReads,
            kodDog,
            interval,
        })
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}
